import { Alert, Button, Snackbar } from "@mui/material";

const Toaster = ({ open, onClose, message, severity = "success" }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      message={message}
      action={<Button onClick={onClose}>Oui</Button>}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Alert
        severity={severity}
        className="!text-center rounded-full px-6 py-2 shadow-lg"
        sx={{
          backgroundColor: "#f44336",
          color: "white",
          "& .MuiAlert-icon": {
            color: "white",
          },
          "& .MuiAlert-message": {
            color: "white",
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toaster;
